import { createSelector } from 'reselect'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectSelectedGeneralReportsRoots = createSelector(
  [selectGeneralReportsState],
  ({ selectedRoots }) => selectedRoots
)
